import { afterNextRender, Component, inject, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AboutUsProducts } from '../../../shared/types/common.types';
import { SeoService } from '../../../shared/seo.service';
import { SEO_PAGES_CONFIG } from '../../../shared/header/header.lists';
import { Pages } from '../../../shared/types/common.enums';

@Component({
  selector: 'app-family-team',
  imports: [],
  templateUrl: './family-team.component.html',
  styleUrl: './family-team.component.scss'
})
export class FamilyTeamComponent {

  //#region Services

  #sanitizer = inject(DomSanitizer);

  #seoService = inject(SeoService);

  //#endregion

  //#region Properties

  family = signal<AboutUsProducts[]>([]);

  //#endregion

  //#region Constructor

  constructor() {
    this.#seoService.setUpSEOTags(SEO_PAGES_CONFIG[Pages.familyAndTem]);
    afterNextRender(() => this.#load());
  }

  //#endregion

  //#region Methods

  #load() {
    this.family.set([
      {
        img: 'bobby-gayla.jpg',
        title: 'Bobby & Gayla',
        description: this.#sanitizeHtml(`
          <p>
            The <strong>owners of Carlton Farms</strong>, can be found doing chores around the farm daily.
          <p>
          <p>
            They have three children; <strong>Chad, Brad, and Brooke</strong>; who are all involved with the farm operation.
          </p>
          <p>
            Farming can be a fickle business, but Bobby and Gayla have shown the necessary tenacity and creativity to guide Carlton Farms through the tough times.
          </p>
        `),
        alt: 'Smiling couple standing in front of a wooden barn, leaning on an old wagon.'
      },
      {
        img: 'chad-julie.jpg',
        title: 'Chad & Julie',
        description: this.#sanitizeHtml(`
          <p>
            Chad has a <strong>degree in Animal Science and Business</strong>, works full-time on the farm, and is <strong>responsible for Atlanta deliveries and production of beef, pork, and eggs.</strong>
          <p>
          <p>
            While Chad’s wife, Julie,<strong> is now the farm warehouse manager</strong>, she still enjoys getting her hands dirty on the farm when possible.
          </p>
          <p>
            They have three children: Jersey, Atticus, and Wren. Jersey loves all things nature, while Atticus loves tractors and combines.
          </p>
        `),
        alt: 'Family of five smiling outdoors, with parents holding their three young children in a sunny, natural setting.'
      },
      {
        img: 'brad-carol.jpg',
        title: 'Brad & Carol',
        description: this.#sanitizeHtml(`
          <p>
            Brad has a <strong>degree in dairy management</strong> from Utah State and is responsible for the <strong>day-to-day operations of the dairy</strong> as well as all field trips and school tour scheduling.
          <p>
          <p>
            Carol is a school teacher at a local elementary school.
          </p>
          <p>
            Brad and Carol have two children, Sara and Ty, who are both great students and can be found at the dairy most weekends working on their latest project.
          </p>
        `),
        alt: 'Family of four with a golden retriever puppy posing together on a rural path lined with trees and a white fence.'
      },
      {
        img: 'kendall-brooke.jpg',
        title: 'Kendall & Brooke',
        description: this.#sanitizeHtml(`
          <p>
            Brooke is a <strong>nurse but often works on the farm as well</strong> - if you have been on a field trip to Carlton Farms, Brooke may have been your guide.
          <p>
          <p>
            Kendall works in law enforcement with the State of Georgia, and they have one child, Bax.
          </p>
        `),
        alt: 'Couple sitting in a cotton field with their baby in a red wagon labeled "radio flyer," all smiling at the camera.'
      }
    ])
  }

  #sanitizeHtml(html: string): SafeHtml {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return this.#sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }

  //#endregion
}
